import React, { createContext, useContext, useMemo } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const GoogleMapsLoaderContext = createContext();

export const GoogleMapsLoaderProvider = ({ children }) => {
  // Google Maps APIのオプションにlanguageを追加して、日本語表記を強制する
  const loaderOptions = useMemo(() => ({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    language: 'ja', // 言語を日本語に設定
    region: 'JP' // 日本地域に設定
  }), []);

  const { isLoaded, loadError } = useJsApiLoader(loaderOptions);

  return (
    <GoogleMapsLoaderContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsLoaderContext.Provider>
  );
};

export const useGoogleMapsLoader = () => useContext(GoogleMapsLoaderContext);
